import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Color, Icons } from '@lsq-frontend/common-ui';

@Component({
    selector: 'admin-buyer-configuration-paid-fees',
    template: `
        <buyer-configuration-section
            [hasClickedSave]="hasClickedSave"
            sectionTitle="Buyer Paid Early Payment Fees"
            sectionFormControlName="buyerPaidEarlyPaymentFeesEnabled"
            [sectionFormGroup]="buyerPaidEarlyPaymentFeesFormGroup"
        >
            <form [formGroup]="buyerPaidEarlyPaymentFeesFormGroup" [style.padding]="'2rem 3rem'">
                <div class="row">
                    <div class="col-12" [style.marginBottom]="'1rem'">
                        <p>
                            Please note that if enabled, this setting will be applied to all
                            suppliers but can be changed at the supplier level.
                        </p>
                    </div>

                    <div class="col-md-6 order-md-1" [style.marginBottom]="'1rem'">
                        <lsq-label
                            label="Buyer Paid Percentage of Early Payment Fees*"
                            subLabel="The percentage (between 0-100) of early payment fees the buyer will be responsible for on behalf of the supplier when early payment is requested. A value of 100 will result in buyers being fully responsible for 100% of the early payment fees for all suppliers enrolled on the platform."
                        ></lsq-label>
                    </div>
                    <div class="col-md-6 order-md-3" [style.marginBottom]="'1rem'">
                        <lsq-input
                            [basicLabel]="true"
                            name="buyerPaidFeePercentage"
                            formControlName="buyerPaidFeePercentage"
                            [group]="buyerPaidEarlyPaymentFeesFormGroup"
                            [appendIcon]="[icons.FaPercent, color.GraphicGray]"
                        >
                        </lsq-input>
                    </div>

                    <div class="col-md-6 order-md-2" [style.marginBottom]="'1rem'">
                        <lsq-label
                            label="Supplier Paid Percentage of Early Payment Fees"
                            subLabel="The percentage (between 0-100) of early payment fees the supplier will be responsible for. A value of 100 will result in suppliers being responsible for 100% of the early payment fees for all suppliers enrolled on the platform."
                        ></lsq-label>
                    </div>

                    <div class="col-md-6 order-md-4" [style.marginBottom]="'1rem'">
                        <lsq-input
                            [basicLabel]="true"
                            name="supplierPaidFeePercentage"
                            [group]="buyerPaidEarlyPaymentFeesFormGroup"
                            [appendIcon]="[icons.FaPercent, color.GraphicGray]"
                            [disabled]="'true'"
                            [inputValue]="
                                (
                                    100 -
                                    buyerPaidEarlyPaymentFeesFormGroup.get('buyerPaidFeePercentage')
                                        .value
                                ).toString()
                            "
                        >
                        </lsq-input>
                    </div>
                </div>
            </form>
        </buyer-configuration-section>
    `
})
export class AdminBuyerConfigurationPaidFeesComponent {
    @Input() public buyerPaidEarlyPaymentFeesFormGroup: FormGroup;
    @Input() public hasClickedSave: boolean;

    public readonly icons = Icons;
    public readonly color = Color;
}
